import React, { useState, useEffect } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Dialog from '@material-ui/core/Dialog';
import Button from '../../../components/sharedComponents/CustomButtons/Button';
import CustomInput from '../../../components/sharedComponents/CustomInput/CustomInput';
import Card from '../../../components/sharedComponents/Card/Card';
import CardBody from '../../../components/sharedComponents/Card/CardBody';
import CardHeader from '../../../components/sharedComponents/Card/CardHeader';
import CardFooter from '../../../components/sharedComponents/Card/CardFooter';

import styles from './styles';

const useStyles = makeStyles(styles);

const CredencialesPage = ({ onUpdate, open, handleClose }) => {
  const classes = useStyles();

  const [oldPwd, setOldPwd] = useState('');
  const [newPwd, setNewPwd] = useState('');
  const [checkPwd, setCheckPwd] = useState('');
  const [check, setCheck] = useState(false);
  const [error, setError] = useState(false);
  const [errorOlld, setErrorOld] = useState(false);

  const mensaje = 'La contraseña debe tener al menos 8 caracteres';
  const mensaje2 = 'Deben coincidir las dos contraseñas';

  useEffect(() => {
    if (newPwd == checkPwd) {
      return setErrorOld(false);
    }
    return () => setErrorOld(true);
  }, [newPwd, checkPwd]);

  const handleChangeNew = (event) => {
    setNewPwd(event.target.value);
    if (newPwd.length <= 2) {
      return (setCheck(false), setError(false));
    } if (newPwd.length >= 8) {
      return (setCheck(true), setError(false));
    } setError(true);
  };

  const handleChangeOld = (event) => {
    setCheckPwd(event.target.value);
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    onUpdate({
      clave_actual: oldPwd,
      clave_nueva: checkPwd,
    });
  };

  return (
    <div>
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <Card>
          <form onSubmit={handleSubmit}>
            <CardHeader color="customAuteco">
              <h3 className={classes.cardTitleWhite}>Cambia tu contraseña</h3>
            </CardHeader>
            <CardBody>
              <Grid container>
                <Grid item xs={12}>
                  <CustomInput
                    labelText="Contraseña actual"
                    id="passAct"
                    value={oldPwd}
                    formControlProps={{
                      fullWidth: true,
                    }}
                    inputProps={{
                      onChange: (event) => setOldPwd(event.target.value),
                      type: 'password',
                      autoComplete: 'off',
                    }}
                  />
                </Grid>
                <Grid item xs={12}>
                  <CustomInput
                    labelText="Nueva contraseña"
                    id="passNew"
                    value={newPwd}
                    success={check}
                    formControlProps={{
                      fullWidth: true,
                    }}
                    inputProps={{
                      type: 'password',
                      onChange: handleChangeNew,
                      autoComplete: 'off',
                    }}
                  />
                  {error && <p>{mensaje}</p>}
                </Grid>
                <Grid item xs={12}>
                  <CustomInput
                    labelText="Repite la contraseña"
                    id="passNewCheck"
                    success={check}
                    error={errorOlld}
                    value={checkPwd}
                    formControlProps={{
                      fullWidth: true,
                    }}
                    inputProps={{
                      type: 'password',
                      onChange: handleChangeOld,
                      autoComplete: 'off',
                    }}
                  />
                  {errorOlld && <p>{mensaje2}</p>}
                </Grid>
              </Grid>
            </CardBody>
            <CardFooter className={classes.cardFooter}>
              <Button disabled={errorOlld} type="onSubmit" color="warning">
                Actualizar
              </Button>
            </CardFooter>
          </form>
        </Card>
      </Dialog>
    </div>
  );
};

export default CredencialesPage;
